import { render, staticRenderFns } from "./SpacePagePrivacyError.vue?vue&type=template&id=2b1e903f"
import script from "./SpacePagePrivacyError.js?vue&type=script&lang=js&external"
export * from "./SpacePagePrivacyError.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports